import type { OrderDetailDTO, OrderStatus } from "../types";

/** Statuses that can be reverted one step */
export const REVERTABLE_STATUSES: ReadonlySet<OrderStatus> = new Set([
  "paid",
  "ready_to_ship",
  "shipped",
  "delivered",
  "picked_up",
  "returned",
]);

export function getPreviousStatus(
  order: Pick<OrderDetailDTO, "status" | "shippedAt" | "deliveredAt">,
): OrderStatus | null {
  switch (order.status) {
    case "paid":
      return "draft";
    case "ready_to_ship":
      return "paid";
    case "shipped":
      return "ready_to_ship";
    case "delivered":
      return "shipped";
    case "picked_up":
      return order.deliveredAt ? "delivered" : "shipped";
    case "returned":
      if (order.deliveredAt) return "delivered";
      return order.shippedAt ? "shipped" : "ready_to_ship";
    default:
      return null;
  }
}

export function canRevertOrderStatus(status: OrderStatus): boolean {
  return REVERTABLE_STATUSES.has(status);
}

export function requiresStockRestore(
  from: OrderStatus,
  to: OrderStatus,
): boolean {
  return from === "paid" && to === "draft";
}

export function requiresStockDeduct(
  from: OrderStatus,
  to: OrderStatus,
): boolean {
  return (
    from === "returned" &&
    (to === "shipped" || to === "ready_to_ship" || to === "delivered")
  );
}
